"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
require("./LessonContent.less");
var _utils = require("./utils");
var _TextButton = require("../../components/Button/TextButton");
var _lessons = require("../../utils/lessons.util");
var _ = require("./..");
var _utils2 = require("../../utils/utils");
var _LessonsNavLink = _interopRequireDefault(require("./partials/LessonsNavLink"));
var _classnames = _interopRequireDefault(require("classnames"));
var _CourseContentDisclaimer = _interopRequireDefault(require("./partials/CourseContentDisclaimer"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
var BackToSectionLink = function BackToSectionLink(_ref) {
  var sectionName = _ref.sectionName,
    route = _ref.route,
    className = _ref.className;
  return /*#__PURE__*/_react.default.createElement(_TextButton.TextButton, {
    size: "small",
    className: (0, _classnames.default)('tw-label-medium', className),
    underline: false,
    route: route,
    icon: "caret-left-heavy-16",
    iconPosition: "left"
  }, "Back to ", sectionName);
};
var LessonContentMobile = function LessonContentMobile(_ref2) {
  var course = _ref2.course,
    selectedLesson = _ref2.selectedLesson,
    lessonContent = _ref2.lessonContent;
  var lessons = course.lessons,
    courseTitle = course.title,
    courseSlug = course.slug;
  var lessonTitle = selectedLesson.title,
    ordinal = selectedLesson.ordinal;
  var nextLesson = (0, _utils.getNextLesson)(selectedLesson, lessons);
  var previousLesson = nextLesson ? undefined : (0, _utils.getPreviousLesson)(selectedLesson, lessons);
  (0, _lessons.useLessonIframeVideoLoading)(selectedLesson);
  (0, _react.useEffect)(function () {
    if (selectedLesson) {
      _utils2.ScrollTo.top({
        isSmooth: true
      });
    }
  }, [selectedLesson]);
  (0, _react.useEffect)(function () {
    return (0, _.trackUserEvent)({
      eventName: 'Visit lesson',
      eventValues: {
        courseTitle: courseTitle,
        lessonTitle: lessonTitle
      }
    });
  }, []);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "w-full"
  }, /*#__PURE__*/_react.default.createElement(BackToSectionLink, {
    className: (0, _classnames.default)('w-full flex justify-start px-[20px] py-[20px]', 'border-0 border-b-[1px] border-t-[1px] border-solid border-t-grey-10 border-b-grey-20'),
    sectionName: courseTitle,
    route: (0, _lessons.composeCourseRoute)(courseSlug)
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "w-full flex justify-start bg-beige1-10"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "text-grey-55 tw-caption-regular mt-[24px] ml-[20px]"
  }, courseTitle)), /*#__PURE__*/_react.default.createElement("div", {
    id: "lesson-content",
    className: "lesson-content-mobile flex-grow bg-beige1-10 pt-[8px] pb-[24px]"
  }, /*#__PURE__*/_react.default.createElement("h2", {
    className: "tw-subtitle-sm-regular"
  }, (0, _lessons.getLessonTitleWithOrdinal)(lessonTitle, ordinal)), lessonContent, /*#__PURE__*/_react.default.createElement(_CourseContentDisclaimer.default, null)), nextLesson && /*#__PURE__*/_react.default.createElement(_LessonsNavLink.default, {
    route: (0, _lessons.composeLessonRoute)(courseSlug, nextLesson.slug),
    lesson: nextLesson
  }), previousLesson && /*#__PURE__*/_react.default.createElement(_LessonsNavLink.default, {
    route: (0, _lessons.composeLessonRoute)(courseSlug, previousLesson.slug),
    lesson: previousLesson,
    linkPrefix: "Previous"
  }));
};
var _default = LessonContentMobile;
exports.default = _default;